import { render, staticRenderFns } from "./DoneToDashboardFooter.vue?vue&type=template&id=0672b7b8"
import script from "./DoneToDashboardFooter.vue?vue&type=script&lang=ts"
export * from "./DoneToDashboardFooter.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports